/* file: brand/earlybird.js -- the OCEAN 2 early-bird offer.
 * Countdown, "?" tooltips, model tabs, sticky bar, sign-up confirmation and
 * the once-a-day pop-up. Everything keys off data-efb-* attributes, so the
 * homepage hero and the offer page share one file. */
(function () {
  "use strict";
  var doc = document;
  /* Visible text goes through T(): the page's ef-i18n-js snippet fills
     window.efT with the reader's language, keyed by this English. */
  var T = function (s) { return (window.efT && window.efT[s]) || s; };
  var each = function (sel, fn) { Array.prototype.forEach.call(doc.querySelectorAll(sel), fn); };
  var ended = function (el) { var e = Date.parse(el.getAttribute("data-efb-end") || ""); return e && Date.now() > e; };

  /* After the early-bird period the hero takes itself off the homepage and
     /pages/home-energy, so an expired offer is never advertised. */
  each(".efb--promo .efb-hero[data-efb-end]", function (h) { if (ended(h)) h.hidden = true; });
  var store = { get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
                set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} } };

  /* Countdown to the end of the early-bird period (Malaysia time). */
  each("[data-efb-countdown]", function (root) {
    var end = Date.parse(root.getAttribute("data-efb-countdown"));
    var f = { d: root.querySelector("[data-efb-d]"), h: root.querySelector("[data-efb-h]"),
              m: root.querySelector("[data-efb-m]"), s: root.querySelector("[data-efb-s]") };
    var pad = function (n) { return (n < 10 ? "0" : "") + n; };
    function tick() {
      var left = Math.max(0, end - Date.now()), s = Math.floor(left / 1000);
      f.d.textContent = pad(Math.floor(s / 86400)); f.h.textContent = pad(Math.floor(s / 3600) % 24);
      f.m.textContent = pad(Math.floor(s / 60) % 60); f.s.textContent = pad(s % 60);
      if (!left) { root.classList.add("is-over"); root.querySelector(".efb-cd__ends").textContent = T("The early-bird period has ended."); return; }
      setTimeout(tick, 1000 - (Date.now() % 1000));
    }
    if (end) tick();
  });

  /* "?" tooltips: one open at a time; Escape or a click elsewhere closes. */
  function closeTips(except) {
    each("[data-efb-tip][aria-expanded='true']", function (b) {
      if (b === except) return;
      b.setAttribute("aria-expanded", "false"); b.nextElementSibling.hidden = true;
    });
  }
  doc.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-efb-tip]");
    if (b) { var open = b.getAttribute("aria-expanded") !== "true"; closeTips(b);
      b.setAttribute("aria-expanded", open ? "true" : "false"); b.nextElementSibling.hidden = !open; return; }
    closeTips(null);
  });
  doc.addEventListener("keydown", function (e) { if (e.key === "Escape") closeTips(null); });

  /* Model chooser tabs. */
  each("[data-efb-chooser]", function (root) {
    var tabs = root.querySelectorAll("[data-efb-tab]"), panes = root.querySelectorAll(".efb-ch__pane");
    Array.prototype.forEach.call(tabs, function (t, i) {
      t.addEventListener("click", function () {
        Array.prototype.forEach.call(tabs, function (x, j) { x.setAttribute("aria-selected", j === i ? "true" : "false"); });
        Array.prototype.forEach.call(panes, function (p, j) { p.hidden = j !== i; p.classList.toggle("is-on", j === i); });
      });
    });
  });

  /* In-page tabs follow the section in view; the sticky bar shows once the
     hero has gone and hides over the reserve cards and after the period. */
  var nav = doc.querySelector("[data-efb-tabs]"), bar = doc.querySelector("[data-efb-sticky]");
  if (bar && !ended(bar)) bar.hidden = false;
  var hero = doc.querySelector(".efb-hero--center"), reserve = doc.getElementById("reserve");
  var ticking = false;
  function frame() {
    ticking = false;
    if (nav) {
      var on = null;
      each(".efb-tabs__a", function (a) {
        var t = doc.getElementById(a.getAttribute("href").slice(1));
        if (t && t.getBoundingClientRect().top < 200) on = a;
      });
      each(".efb-tabs__a", function (a) { a.classList.toggle("is-on", a === (on || doc.querySelector(".efb-tabs__a"))); });
    }
    if (bar && !bar.hidden) {
      var past = !hero || hero.getBoundingClientRect().bottom < 0;
      var r = reserve && reserve.getBoundingClientRect(), over = r && r.top < innerHeight && r.bottom > 0;
      bar.classList.toggle("is-on", past && !over);
    }
  }
  if (nav || bar) {
    window.addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
    frame();
  }

  /* Sign-up: Shopify redirects back with ?customer_posted=true. */
  if (/[?&]customer_posted=true/.test(location.search)) {
    each("[data-efb-form]", function (f) { f.classList.add("is-done"); f.querySelector(".efb-up__done").hidden = false; });
  }

  /* The pop-up: after 2.5s, at most once a day, never after the early-bird
     period, never on the offer page itself. */
  var pop = doc.querySelector("[data-efb-pop]");
  /* Off (owner, 03NOV2026: "disable ocean pop up window, and change to 11:11 with monthly
     installment"): the 11.11 pop-up carries the instalment line instead. The hero, the page
     and the coupon stay. Put back by deleting EFB_POP_OFF. */
  var EFB_POP_OFF = true;
  /* 11.11: while the Spin & Save draw is on the page, it is the one pop-up. */
  if (!EFB_POP_OFF && pop && typeof pop.showModal === "function" && !doc.querySelector("[data-ef-spinmodal]") && !ended(pop) && !/early-bird/.test(location.pathname)) {
    var KEY = "efb-pop-seen", last = +store.get(KEY) || 0;
    var force = /[?&]efb_pop=1/.test(location.search);
    if (force || Date.now() - last > 864e5) {
      setTimeout(function () { if (!pop.open) { pop.showModal(); store.set(KEY, String(Date.now())); } }, force ? 300 : 2500);
    }
    pop.addEventListener("click", function (e) {
      if (e.target === pop || (e.target.closest && e.target.closest("[data-efb-close]"))) pop.close();
    });
    each("[data-efb-close-go]", function (a) { a.addEventListener("click", function () { pop.close(); }); });
  }
})();
